<template>
  <el-dialog title="编辑项目" width="60%" :visible.sync="diaVisible" append-to-body @close="handleClose()">
    <el-form :model="form" :rules="formRules" label-width="140px" ref="form" style="padding-right: 20px">
      <el-row>
        <el-col :span="10" :offset="2">
          <el-form-item label="项目名称:" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="项目阶段：" prop="projectType">
            <el-select clearable v-model="form.projectType">
              <el-option
                v-for="item in projectStage"
                :label="item.name"
                :value="item.uid"
                :key="item.uid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10" :offset="2">
          <el-form-item label="对接人:" prop="contact">
            <el-input v-model="form.contact"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="对接人职务:" prop="contactDuty">
            <el-input v-model="form.contactDuty"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10" :offset="2">
          <el-form-item label="对接人联系方式:" prop="contactTel">
            <el-input v-model="form.contactTel"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="微医后续落地部门:" prop="landingDepartment">
            <el-input v-model="form.landingDepartment"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10" :offset="2">
          <el-form-item label="落地部门对接人:" prop="landingDocker">
            <el-input v-model="form.landingDocker"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <crm-button
        :buttonType="'plain'"
        :text="'取消'"
        @click="handleClose()">
      </crm-button>
      <crm-button :text="'确定'" @click="handleSubmit()"></crm-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CrmButton from '@/components/base/crmButton';

export default {
  components: {
    CrmButton,
  },
  props: {
    detail: Object,
    visible: Boolean,
    id: String,
  },
  data() {
    return {
      diaVisible: false,
      form: {
        inspectId: null,
        name: null,
        projectType: null,
        contact: null,
        contactDuty: null,
        contactTel: null,
        landingDepartment: null,
        landingDocker: null,
      },
      formRules: {
        name: [
          { required: true, message: '请填写项目名称', trigger: 'blur' },
          { max: 30, message: '最多30个字', trigger: 'blur' },
        ],
        projectType: [{ required: true, message: '请选择项目阶段', trigger: 'change' }],
        contact: [
          { required: true, message: '请填写对接人', trigger: 'blur' },
          { max: 10, message: '最多10个字', trigger: 'blur' },
        ],
        contactDuty: [{ max: 20, message: '最多20个字', trigger: 'blur' }],
        contactTel: [{ max: 20, message: '最多20个字', trigger: 'blur' }],
        landingDepartment: [
          { required: true, message: '请填写微医后续落地部门', trigger: 'blur' },
          { max: 50, message: '最多50个字', trigger: 'blur' },
        ],
        landingDocker: [
          { required: true, message: '请填写落地部门对接人', trigger: 'blur' },
          { max: 10, message: '最多10个字', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      projectStage: 'common/projectStage',
    }),
  },
  watch: {
    visible(val) {
      this.diaVisible = val;
      if (!this.projectStage.length) {
        this.getProjectStage({
          pageNumber: 1,
          pageSize: 100,
          code: 'category_project_type',
        });
      }
      if (val) this.form = this.detail;
    },
  },
  methods: {
    ...mapActions({
      getProjectStage: 'common/getProjectStage',
      editProject: 'customer/editProject',
    }),
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.inspectId = this.id;
          this.editProject(this.form).then(() => {
            this.$message.success('编辑成功');
            this.handleClose();
            this.$emit('success');
          });
        }
      });
    },
    handleClose() {
      this.$refs.form.resetFields();
      this.$emit('close');
    },
  },
};
</script>

<style>

</style>
